<script setup lang="ts">
defineProps<{
  nutritionFacts: {
    kcal: number
    proteins: number
    carbs: number
    fats: number
    weight: number
  }
  name: string
}>()
</script>

<template>
  <div class="facts">
    <header class="facts__header">
      <h3 class="facts__title" v-text="name" />
      <div class="facts__kcal">Пищевая ценность</div>
    </header>

    <div class="facts__table table">
      <div class="table__row">
        <div class="table__col">Пищевая ценность</div>
        <div class="table__col table__col_data" v-text="`${nutritionFacts.kcal} ккал`" />
      </div>
      <div class="table__row">
        <div class="table__col">Белки</div>
        <div class="table__col table__col_data" v-text="`${nutritionFacts.proteins} г`" />
      </div>
      <div class="table__row">
        <div class="table__col">Жиры</div>
        <div class="table__col table__col_data" v-text="`${nutritionFacts.fats} г`" />
      </div>
      <div class="table__row">
        <div class="table__col">Улеводы</div>
        <div class="table__col table__col_data" v-text="`${nutritionFacts.carbs} г`" />
      </div>
      <div class="table__row">
        <div class="table__col">Вес</div>
        <div class="table__col table__col_data" v-text="`${nutritionFacts.weight} г`" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.facts {
  background-color: $sub-green;
  min-width: 240px;
  max-width: calc(100vw - 32px);
  padding: 24px 16px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.07);
  border-radius: 16px;

  &__header {
    margin-bottom: 16px;
  }

  &__title {
    @include h4-6;
    color: $primary-text;
    margin-bottom: 4px;
  }

  &__kcal {
    @include h7-1;
    color: $sub-text;
  }

  &__table {
  }
}
.table {
  &__row {
    display: flex;
    gap: 8px;
    justify-content: space-between;
  }

  &__col {
    @include h6-2;
    color: $primary-text;
    &_data {
      white-space: nowrap;
    }
  }
}
</style>
